





























































import {
  defineComponent,
  getCurrentInstance,
  ComponentInternalInstance,
  computed,
  Ref,
  ref,
  watch,
  onMounted,
  onUnmounted,
  PropType,
  toRefs,
} from '@vue/composition-api';
import { TreeNodeValue, TreeNodeModel } from 'tdesign-vue';
import { CaretRightSmallIcon, LoadingIcon, CaretDownSmallIcon } from 'tdesign-icons-vue';

// 引入 compositions
import { ResizeObserver } from 'resize-observer';
import teamHandler from '@/renderer/views/desktop/ManageConsole/TeamManagement/compositions/teamHandler';
import treeHandler from '@/renderer/components/TeamTree/compositions/treeHandler';
import searchHandler from '@/renderer/components/dialog/AddTransfer/compositions/searchHandler';

// 引入工具类
import ipc from '@/renderer/scripts/utils/ipc';
import store from '@/renderer/store';
import { SMH } from '@/renderer/scripts/smh';
import { getCheckManagementPermission } from '@/renderer/scripts/utils/UserRole';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import storage from '@/renderer/scripts/utils/storage';
interface NewNodeType {
  children: false;
  id: number;
  name: string;
  parentId: number;
}
export default defineComponent({
  components: {
    CaretRightSmallIcon,
    LoadingIcon,
    CaretDownSmallIcon,
  },
  props: {
    // 树组件类型，目前只有企业空间和团队管理里用到teamSpaceTree|teamManagementTree
    treeType: {
      type: String,
      default: '',
    },
    /**
     * 是否显示团队下的人数
     */
    showUserCount: {
      type: Boolean,
      default: false,
    },
    /**
     * 默认团队路径
     * boolean: false 不选中根结点 | true 选中根结点
     * array: 默认要选中的团队路径
     */
    defaultTeamPath: {
      type: [Array, Boolean],
      default: false,
    },
    /**
     * 是否仅列出所属团队
     */
    checkPermission: {
      type: Number as PropType<0 | 1>,
      default: 0,
    },
    /**
     * 是否仅列出管辖团队
     */
    needCheckManagementPermission: {
      type: Boolean,
      default: false,
    },
    /**
     * 列出团队是否带路径
     */
    withPath: {
      type: Boolean,
      default: true,
    },
    // 搜索关键词
    keyword: {
      type: String,
      default: '',
    },
    rid: {
      type: Number,
      defaule: -1,
    },
  },
  setup(props, context) {
    const $this = context;
    const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const router = vm.$router;
    const currentRouteName = router.currentRoute.name;
    const { fromTransit } = vm.$route?.params;
    const loading = ref(false);
    const treeData: Ref<SMH.TeamTreeNode[]> = ref([]);
    const isShowRootTeam = ref(false);

    const { treeType } = toRefs(props);
    // 只有后台管理的团队管理的团队树才需要查询noSpace的团队 withNoSpaceTeams传1
    const withNoSpaceTeams = computed(() => (treeType.value === 'teamManagementTree' ? 1 : undefined));

    const rootId = ref<number>(-1);
    const actived: Ref<number[]> = ref([]);
    const currentId = computed(() => actived.value[0]);
    const expanded = ref<number[]>([]);
    const treeKeys = {
      value: 'id',
      label: 'name',
      children: 'children',
    };
    const { listTeam } = teamHandler(props.checkPermission, props.needCheckManagementPermission);
    const { findTeamIdByPath } = treeHandler({
      checkPermission: props.checkPermission,
      needCheckManagementPermission: props.needCheckManagementPermission,
      withPath: props.withPath,
    });
    const {
      teamData: searchTeamData,
      loading: searchLoading,
      searchKey,
      methods: searchMethods,
    } = searchHandler({
      onlySearchTeam: true,
      needCheckManagementPermission: props.needCheckManagementPermission,
    });
    const isSearched = ref(false);
    const searchKeyWord = computed(() => props.keyword);
    const methods = {
      // 加载子节点
      async load(node: TreeNodeModel) {
        const teamId = node.data?.id || '';
        const res = await listTeam({ teamId, withPath: props.withPath, withNoSpaceTeams: withNoSpaceTeams.value });
        const subTeam: any = (res.children as SMH.TeamTreeNode[]).map(item => ({
          ...item,
          children: item.children && item.children.length > 0,
        }));
        if (!node.data.children || !Array.isArray(node.data.children)) {
          node.data.children = [];
        }
        if (!node.data.loaded) {
          node.data.children.push(...subTeam);
          node.data.loaded = true;
        }
        return subTeam;
      },
      getParents(value: TreeNodeValue) {
        const { tree }: any = (currComponent as ComponentInternalInstance).refs;
        const parents = tree.getParents(value);
        return parents;
      },
      getItem(value: TreeNodeValue) {
        const { tree }: any = (currComponent as ComponentInternalInstance).refs;
        return tree.getItem(value);
      },
      // 清除结点激活态
      clearActiveNode() {
        actived.value = [];
      },
      // 选择节点
      clickNode(context: { e: Event; node: TreeNodeModel }) {
        const { node, e } = context;
        const nodeTagName = (e.target as HTMLElement).nodeName;
        if (nodeTagName === 'use' || nodeTagName === 'svg') {
          return;
        }
        actived.value = [context.node.value as number];
        $this.emit('select-change', {
          ...node,
        });
      },
      // 根据路径激活节点
      async nodeActiveByPath(
        _path?: string[],
        options?: {
          init?: boolean;
          noEmit?: boolean;
        },
      ) {
        const rootNode = treeData.value[0];
        if (!rootNode) return;
        const defaultTeamPath = Array.isArray(props.defaultTeamPath) ? props.defaultTeamPath : rootNode.path;
        const path = _path || (defaultTeamPath as string[]);
        if (!path) {
          return;
        }
        // defaultTeamPath 为数组时，选中对应的路径
        const { defaultId, defaultTeam, parentIds, teamData } = await findTeamIdByPath(path, rootNode);
        treeData.value = isShowRootTeam.value ? [teamData] : (teamData.children as SMH.TeamTreeNode[]);
        // 此处不能直接用currentRouteName vm.$route并非响应书 要现取现用
        if (defaultId !== -1 && vm.$route.name === 'teamSpace') {
          actived.value = [defaultId];
          !options?.noEmit &&
            $this.emit('select-change', {
              data: defaultTeam,
              init: options?.init,
            });
        } else {
          actived.value = [rootId.value];
          !options?.noEmit &&
            $this.emit('select-change', {
              data: rootNode,
              init: options?.init,
            });
        }
      },
      // 增加节点
      appendNode(newNode: NewNodeType, parentNodeId = currentId.value) {
        const { tree }: any = (currComponent as ComponentInternalInstance).refs;
        const nodeInfo = tree.getItem(parentNodeId);
        if (!nodeInfo) {
          return;
        }
        const isRoot = nodeInfo.getIndex() === 0;
        if (isAdminOrSuperAdmin.value && isRoot) {
          nodeInfo.data.loaded = true;
        }
        // 没加载子节点就不用append，等待下一次load子节点
        if (nodeInfo.data.children && !nodeInfo.data?.loaded) {
          nodeInfo.data.children = true;
          return;
        }
        tree.appendTo(parentNodeId, newNode);
        if (!nodeInfo.data.children) {
          nodeInfo.data.children = [];
        }
        nodeInfo.data.children.push(newNode);
      },
      // 编辑团队信息后更新节点的展示内容
      editNode(params: { name?: string; space?: string; defaultRoleId?: string }) {
        const { tree }: any = currComponent.refs;
        const node = tree.getItem(currentId.value);
        Object.assign(node.data, params);
      },
      // 删除节点
      deleteNode() {
        const { tree }: any = currComponent.refs;
        const parent = tree.getParent(currentId.value);
        const res = methods.findDeepData(treeData.value, currentId.value);
        if (res.parent && res.index) {
          res.parent.splice(res.index, 1);
        }
        tree.remove(currentId.value);
        if (parent?.data) {
          actived.value = [parent.data.id];
          $this.emit('select-change', parent);
        }
      },
      // 在原始数据中查找
      findDeepData(
        list: SMH.TeamTreeNode[],
        id: number,
      ): {
        index: number;
        parent: SMH.TeamTreeNode[];
      } {
        const res: {
          index: number;
          parent: SMH.TeamTreeNode[];
        } = {
          index: -1,
          parent: [],
        };
        for (let i = 0; i < list.length; i++) {
          const item = list[i];
          if (item.id === id) {
            res.index = i;
            res.parent = list;
            break;
          }
          if (Array.isArray(item.children)) {
            return methods.findDeepData(item.children, id);
          }
        }
        return res;
      },
      // 搜索团队
      searchNode() {
        searchKey.teamOrMemberCache = searchKeyWord.value;
        // 搜索时清空已选节点
        actived.value = [];
        if (searchKeyWord.value === '') {
          methods.initSearch();
          methods.initData();
          isSearched.value = false;
        } else {
          isSearched.value = true;
          searchMethods.onSearchTeamsOrMembers(searchKey.teamOrMemberCache, rootId.value);
        }
      },
      // 搜索更多
      async searchMore() {
        searchMethods.pullTeamList({ withNoSpaceTeams: 1 });
      },
      // 清空搜索状态
      initSearch() {
        searchMethods.cancelLastSearch();
      },
      // 初始化
      async initData({ silentLoading } = { silentLoading: false }) {
        loading.value = !silentLoading;
        const res = await listTeam({ teamId: '', withPath: props.withPath, withNoSpaceTeams: withNoSpaceTeams.value });
        rootId.value = +res.id;
        context.emit('update:rid', rootId.value);
        if (!res.children) {
          res.children = [];
        }
        res.children.forEach((item: any) => {
          item.children = item.children && item.children.length > 0;
        });
        await methods.getRenderTreeData();
        treeData.value = isShowRootTeam.value ? [res] : res.children;
        if (fromTransit) {
          // web上传列表打开赋值路径
          const teamPathInfo = storage.get<TeamPathStorageInfo>(storage.StoreKey.TEAM_PATH);
          const { path } = teamPathInfo;
          await methods.nodeActiveByPath(path, {
            init: true,
          });
        } else if (typeof props.defaultTeamPath === 'boolean') {
          expanded.value = [rootId.value];
          if (props.defaultTeamPath) {
            actived.value = isShowRootTeam.value ? [rootId.value] : [res.children[0].id];
            $this.emit('select-change', {
              data: isShowRootTeam.value ? res : res.children[0],
            });
          }
        } else {
          expanded.value = [rootId.value];
          await methods.nodeActiveByPath(props.defaultTeamPath as string[], {
            init: true,
          });
        }
        loading.value = false;
        const { treeComponent }: any = (currComponent as ComponentInternalInstance).refs;

        if (treeComponent && props.treeType === 'teamSpaceTree') {
          observer.observe(treeComponent);
          // 企业空间树展示时上报一级部门列表
          const firstLevel = treeData.value.length === 1 ? treeData.value[0] : {};
          if ((firstLevel as SMH.TeamTreeNode).children) {
            const names = (firstLevel as SMH.TeamTreeNode).children?.map(item => item.name).join(',');
            reporter.report('architecture_one', { list: names });
          }
        }
      },
      // 团队下成员更新后，获取最新成员数量
      async updateMemberCount() {
        const res = await listTeam({
          teamId: currentId.value,
          withPath: false,
          withNoSpaceTeams: withNoSpaceTeams.value,
        });
        const { userCount } = res;
        const { tree }: any = currComponent.refs;
        const node = tree.getItem(currentId.value);
        node.data.userCount = userCount;
      },
      async getRenderTreeData() {
        // 过滤根团队（团队管理员即便无根团队权限，后端仍然返回根目录）
        const { canManageTeams } = store.getters.userBaseInfo;
        const checkManagementPermission = await getCheckManagementPermission();
        // 企业空间的树需要展示根节点
        isShowRootTeam.value =
          treeType.value === 'teamSpaceTree'
            ? true
            : !checkManagementPermission || canManageTeams?.includes(rootId.value);
      },
    };
    methods.initData();

    const observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const scrollbarStyles = getComputedStyle(document.documentElement, '::-webkit-scrollbar');
        const scrollbarHeight = parseInt(scrollbarStyles.getPropertyValue('height') || '0', 10);
        context.emit('height-change', entry.contentRect.height + scrollbarHeight);
      });
    });
    watch(expanded, val => {
      if (!val.includes(rootId.value)) {
        // 根目录一直要打开
        val.push(rootId.value);
      }
    });
    watch(searchTeamData, () => {
      // 搜索结果渲染
      actived.value = [];
      treeData.value = searchTeamData.list;
    });
    // 避免偶尔切换路由时，企业树node节点还是激活态
    watch(
      () => vm.$route,
      val => {
        if (val.name !== 'teamSpace') {
          actived.value = [];
        }
      },
    );
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_REFRESH, methods.updateMemberCount);
      ipc.on(ipc.RENDERER_EVENTS_MAP.TEAM_TREE_REFRESH, methods.initData);
      ipc.on(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_ACTIVEATE_BY_TEAMPATH, methods.nodeActiveByPath);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_REFRESH, methods.updateMemberCount);
      ipc.off(ipc.RENDERER_EVENTS_MAP.TEAM_TREE_REFRESH, methods.initData);
      ipc.off(ipc.RENDERER_EVENTS_MAP.TEAM_LIST_ACTIVEATE_BY_TEAMPATH, methods.nodeActiveByPath);
    });
    return {
      loading,
      rootId,
      isShowRootTeam,
      treeKeys,
      treeData,
      actived,
      currentId,
      expanded,
      ...methods,
      isSearched,
      searchKey,
      searchLoading,
      searchTeamData,
      searchMethods,
    };
  },
});
